// Loads GA4 or GTM once the account's ecommerce_settings resolve, gated on
// enable_analytics. Render-once, returns null — lives alongside
// SentryBootstrap at the top of AppProviders.
import { useEffect } from 'react';
import { useEcommerceSettings } from '@core/settings';
import { initAnalyticsFromEcommerceSettings } from '@core/services/gtagService';

export default function AnalyticsBootstrap() {
  const { raw: ecommerceSettings } = useEcommerceSettings();

  useEffect(() => {
    initAnalyticsFromEcommerceSettings(ecommerceSettings);
  }, [ecommerceSettings]);

  return null;
}
